import { createSelector } from "reselect";
import _ from "lodash";
import moment from "moment";

export const selectReportTitles = ({ SubmittedReportsV2_reducer }) => {
    return SubmittedReportsV2_reducer.reportTitles;
};
export const jobYears = ({ SubmittedReportsV2_reducer }) => {
    return SubmittedReportsV2_reducer.job_years;
};
export const selectUserData = ({ SubmittedReportsV2_reducer }) => {
    return SubmittedReportsV2_reducer.userData;
};
export const getRequesting = ({ SubmittedReportsV2_reducer }) => {
    return SubmittedReportsV2_reducer.requestingUserData;
};

export const selectProfile = ({ UserProfile_reducer }) => {
    if (UserProfile_reducer.profile) return UserProfile_reducer.profile.profile;
    else return false;
};
export const selectFilterReportType = ({ SubmittedReportsV2_reducer }) => {
    return SubmittedReportsV2_reducer.reportType;
};
export const selectFilterUserUid = ({ SubmittedReportsV2_reducer }) => {
    return SubmittedReportsV2_reducer.userUid;
};
export const selectSearchDateFrom = ({ SubmittedReportsV2_reducer }) => {
    return SubmittedReportsV2_reducer.dateFrom;
};
export const selectSearchDateTo = ({ SubmittedReportsV2_reducer }) => {
    return SubmittedReportsV2_reducer.dateTo;
};
export const selectDay = ({ SubmittedReportsV2_reducer }) => {
    return SubmittedReportsV2_reducer.day;
};
export const selectClientName = ({ SubmittedReportsV2_reducer }) => {
    return SubmittedReportsV2_reducer.clientName;
};
export const selectReportFilterState = ({ SubmittedReportsV2_reducer }) => {
    return SubmittedReportsV2_reducer.filterState;
};
export const selectRowsPerPage = ({ SubmittedReportsV2_reducer }) => {
    return SubmittedReportsV2_reducer.rowsPerPage;
};
export const selectPage = ({ SubmittedReportsV2_reducer }) => {
    return SubmittedReportsV2_reducer.page;
};
export const selectJobPacksid = ({ SubmittedReportsV2_reducer }) => {
    return SubmittedReportsV2_reducer.jobPacks;
};

export const selectReports = ({ SubmittedReportsV2_reducer }) => {
    if (SubmittedReportsV2_reducer.fullReports)
        return SubmittedReportsV2_reducer.fullReports;
    else return false;
};
export const selectParticularReports = ({ SubmittedReportsV2_reducer }) => {
    if (SubmittedReportsV2_reducer.particularReports)
        return SubmittedReportsV2_reducer.particularReports;
    else return false;
};
export const selectSelectedRow = ({ SubmittedReportsV2_reducer }) => {
    return SubmittedReportsV2_reducer.selectedRow;
};
export const selectChangeReportStatusModal = ({
    SubmittedReportsV2_reducer,
}) => {
    return SubmittedReportsV2_reducer.changeReportStatusModal;
};
export const selectDeleteStatus = ({ SubmittedReportsV2_reducer }) => {
    return SubmittedReportsV2_reducer.deletedStatus;
};
export const selectedDepartment = ({ SubmittedReportsV2_reducer }) => {
    return SubmittedReportsV2_reducer.department;
};
export const selectedArea = ({ SubmittedReportsV2_reducer }) => {
    return SubmittedReportsV2_reducer.area;
};
export const selectReportFilterJobID = ({ SubmittedReportsV2_reducer }) => {
    return SubmittedReportsV2_reducer.jobID;
};
export const selectReportYear = ({ SubmittedReportsV2_reducer }) => {
    return SubmittedReportsV2_reducer.year;
};
export const selectReportMonth = ({ SubmittedReportsV2_reducer }) => {
    return SubmittedReportsV2_reducer.month;
};
export const selectSortTableType = ({ SubmittedReportsV2_reducer }) => {
    return SubmittedReportsV2_reducer.sortTableType;
};

export const selectSortTableKey = ({ SubmittedReportsV2_reducer }) => {
    return SubmittedReportsV2_reducer.sortTableKey;
};

export const selectSortTableAs = ({ SubmittedReportsV2_reducer }) => {
    return SubmittedReportsV2_reducer.sortTableAs;
};
export const selectConfig = ({ MainReducer }) => {
    if (MainReducer.config) return MainReducer.config;
    else return false;
};

export const selectJobYears = createSelector([jobYears], (job = false) => {
    if (job) {
        let years = Object.keys(job).map((e) => {
            return e;
        });
        return years;
    } else return false;
});

export const selectPermissions = createSelector(
    [selectConfig, selectProfile],
    (config = false, { access_level = false }) => {
        if (access_level && config) {
            return config[access_level] ? config[access_level] : false;
        } else return false;
    }
);
export const canRead = createSelector([selectPermissions], (config = false) => {
    return config["submitted_reports"]
        ? config["submitted_reports"].read
        : true;
});
export const canUpdate = createSelector(
    [selectPermissions],
    (config = false) => {
        return config["submitted_reports"]
            ? config["submitted_reports"].update
            : true;
    }
);
export const canCreate = createSelector(
    [selectPermissions],
    (config = false) => {
        return config["submitted_reports"]
            ? config["submitted_reports"].create
            : true;
    }
);
export const canDelete = createSelector(
    [selectPermissions],
    (config = false) => {
        return config["submitted_reports"]
            ? config["submitted_reports"].delete
            : true;
    }
);

export const selectAreas = createSelector(
    [selectProfile],
    ({ areas = false }) => {
        return areas;
    }
);

export const selectDepartments = createSelector(
    [selectProfile],
    ({ departments = false }) => {
        return departments;
    }
);
export const selectUserNames = createSelector(
    [selectUserData],
    (userData = false) => {
        if (userData) {
            let userInfo = Object.keys(userData).map((e) => {
                let uid = e;
                let fname = _.get(userData[e], "profile.first_name") || "N/A";
                let lname = _.get(userData[e], "profile.last_name") || "N/A";
                let deleted = _.get(userData[e], "profile.deleted") || "N/A";
                return { uid, user_name: `${fname} ${lname}`, deleted };
            });
            userInfo = userInfo.filter((e) => {
                if (e.deleted !== true) {
                    return true;
                } else {
                    return false;
                }
            });
            return userInfo.sort((a, b) =>
                a.user_name.localeCompare(b.user_name)
            );
        } else return false;
    }
);

export const selectTableData = createSelector(
    [
        selectUserData,
        selectFilterReportType,
        selectFilterUserUid,
        selectReportFilterState,
        selectSearchDateFrom,
        selectSearchDateTo,
        selectReportFilterJobID,
        selectProfile,
        selectReportYear,
        selectReportMonth,
        selectedDepartment,
        selectedArea,
        selectDay,
        selectClientName,
        selectSortTableType,
        selectSortTableKey,
        selectSortTableAs,
        selectUserNames,
    ],
    (
        userData = false,
        reportType = false,
        userUid = false,
        filterState = false,
        dateFrom = false,
        dateTo = false,
        jobID = false,

        { areas = false, departments = false },
        year,
        month,
        department,
        area,
        day = false,
        clientName = false,
        sortType,
        sortKey,
        sortAs,
        usernames
    ) => {
        let totalReports;
        if (!dateTo) {
            dateTo = dateFrom;
        }
        if (userData) {
            totalReports = _.compact(
                Object.keys(userData).map((e) => {
                    let userReports = _.get(userData[e], "receipts") || null;
                    let year1 = _.get(userReports, year) || null;
                    let month1 = _.get(year1, month) || null;
                    if (month1) return { uid: e, month1 };
                    else return null;
                })
            );
        }
        if (userData) {
            totalReports = _.compact(
                _.flattenDeep(
                    totalReports &&
                        totalReports.map((e) => {
                            return getFlattenedTableReports(
                                e.month1,
                                e.uid,
                                usernames
                            );
                        })
                )
            );
        }
        if (userData) {
            totalReports = totalReports.sort((a, b) => {
                a = new moment(a.timestamp, "DD/MM/YYYY HH:mm:ss"); //.format("DD/MM/YYYY hh:mm:ss");
                b = new moment(b.timestamp, "DD/MM/YYYY HH:mm:ss"); //.format("DD/MM/YYYY hh:mm:ss");
                return b.diff(a);
            });
            if (departments) {
                totalReports = totalReports.filter((e) => {
                    if (e.departments) {
                        let flag = false;
                        departments.map((f) => {
                            if (f === e.departments) {
                                flag = true;
                            }
                            return false;
                        });
                        return flag;
                    } else {
                        return true;
                    }
                });
            }
            if (areas) {
                totalReports = totalReports.filter((e) => {
                    if (e.areas) {
                        let flag = false;
                        areas.map((f) => {
                            if (f === e.areas) {
                                flag = true;
                            }
                            return false;
                        });
                        return flag;
                    } else {
                        return true;
                    }
                });
            }
            if (reportType !== "all_reports") {
                totalReports = totalReports.filter(
                    (e) => e.report_type === reportType
                );
            }
            if (area !== "all_areas") {
                totalReports = totalReports.filter((e) => e.areas === area);
            }
            if (userUid !== "all_users") {
                totalReports = totalReports.filter((e) => e.uid === userUid);
            }
            if (department !== "all_departments") {
                totalReports = totalReports.filter(
                    (e) => e.departments === department
                );
            }
            if (dateFrom) {
                let dt = moment(dateTo).endOf("day");
                let df = moment(dateFrom).startOf("day");
                totalReports = _.compact(
                    totalReports.filter((e) => {
                        let rd = moment(e.timestamp, "DD-MM-YYYY hh:ss:mm");
                        if (rd.isBetween(df, dt)) {
                            return e;
                        } else return null;
                    })
                );
            }
            if (filterState) {
                totalReports = totalReports.filter(
                    (e) => e.worksheet_status === filterState
                );
            }
            if (jobID && jobID !== "") {
                totalReports = _.compact(
                    totalReports.filter((e) => {
                        if (
                            jobID === "N/A" ||
                            jobID === "na" ||
                            jobID === "n/a" ||
                            jobID === "N" ||
                            jobID === "n"
                        ) {
                            return e.subject_name === "reports";
                        } else {
                            return e.subject_name
                                ? e.subject_child.includes(jobID)
                                : null;
                        }
                    })
                );
            }

            if (day) {
                totalReports = totalReports.filter((e) => {
                    let x = moment(e.timestamp).format("MM-DD-YYYY");
                    let y = moment(day).format("DD-MM-YYYY");
                    return moment(x).isSame(y);
                });
            }
            if (clientName) {
                totalReports = _.compact(
                    totalReports.filter((e) => {
                        return e.client_name
                                ? e.client_name.includes(clientName)
                                : null;
                    })
                );
            }

            if (sortKey !== false && sortAs !== false) {
                switch (sortAs) {
                    case "string": {
                        totalReports = totalReports.sort((a, b) => {
                            return a[sortKey]
                                .toLowerCase()
                                .trim()
                                .localeCompare(b[sortKey].toLowerCase().trim());
                        });

                        break;
                    }
                    case "date": {
                        totalReports = totalReports.sort((a, b) => {
                            return (
                                moment(a[sortKey], "DD-MM-YYYY") -
                                moment(b[sortKey], "DD-MM-YYYY")
                            );
                        });

                        break;
                    }
                    case "timestamp": {
                        totalReports = totalReports.sort((a, b) => {
                            return (
                                moment(a[sortKey], "DD-MM-YYYY HH:mm:ss") -
                                moment(b[sortKey], "DD-MM-YYYY HH:mm:ss")
                            );
                        });
                        break;
                    }
                    default: {
                        break;
                    }
                }
            }
            if (sortType === "asc") {
                totalReports = totalReports.reverse();
            }
            return totalReports;
        } else {
            return false;
        }
    }
);
export const paginatedReportList = createSelector(
    [selectTableData, selectRowsPerPage, selectPage],
    (reports = false, rowCount, pageIndex) => {
        if (reports) {
            const start = rowCount * pageIndex;
            const end = start + rowCount;
            const result = reports.slice(start, end);
            return result;
        } else {
            return false;
        }
    }
);
export const totalReportCount = createSelector(
    [selectTableData],
    (reports = false) => {
        return reports ? reports.length : 0;
    }
);
const getFlattenedTableReports = (userReports, uid, usernames) => {
    if (userReports)
        return (
            userReports &&
            Object.keys(userReports).map((e) => {
                if (e !== "holiday_request") {
                    return getTableReciepts(userReports[e], uid, usernames);
                } else return null;
            })
        );
};
export const getTableReciepts = (reciepts, uid, usernames) => {
    let user = _.find(usernames, { uid: uid });
    let user_name = user ? user.user_name : "N/A";
    return Object.keys(reciepts).map((e) => {
        let areas = _.get(reciepts[e], "areas") || null;
        let departments = _.get(reciepts[e], "departments") || null;
        let report_type = _.get(reciepts[e], "report_type") || null;
        let subject_child = _.get(reciepts[e], "subject_child") || null;
        let subject_name = _.get(reciepts[e], "subject_name") || null;
        let timestamp = _.get(reciepts[e], "timestamp") || null;
        let urn = _.get(reciepts[e], "urn") || null;
        let worksheet_status =
            _.get(reciepts[e], "worksheet_status") || "unviewed";
        let uneditable = _.get(reciepts[e], "uneditable") || false;
        let location_lat = _.get(reciepts[e], "location_lat") || null;
        let location_lon = _.get(reciepts[e], "location_lon") || null;
        let client_name = _.get(reciepts[e], "client_name") || "required";
        let connection_status = _.get(reciepts[e], "connection_status") || null;
        let route_prefix =
            subject_name === "reports"
                ? "report-view-standalone/"
                : "report-view/";
        let view_route = `${route_prefix}${subject_name}/${subject_child}/${report_type.replace(
            /_/g,
            "-"
        )}/${timestamp.replace(/ /g, "_").replace(/:/g, ".")}`;

        return {
            uid,
            urn,
            user_name,
            report_type,
            subject_child,
            subject_name,
            timestamp,
            worksheet_status,
            uneditable,
            departments,
            areas,
            location_lat,
            location_lon,
            client_name,
            connection_status,
            view_route:
                uid && report_type && subject_child && subject_name
                    ? view_route
                    : "/submitted-reports-v2",
        };
    });
};

export const getReciepts = (reciepts, uid, jobPacks, fullReports) => {
    return Object.keys(reciepts).map((e) => {
        let report_type = _.get(reciepts[e], "report_type") || null;
        let subject_child = _.get(reciepts[e], "subject_child") || null;
        let subject_name = _.get(reciepts[e], "subject_name") || null;
        let timestamp = _.get(reciepts[e], "timestamp") || null;
        let urn = _.get(reciepts[e], "urn") || null;
        let worksheet_status =
            _.get(reciepts[e], "worksheet_status") || "unviewed";
        let uneditable = _.get(reciepts[e], "uneditable") || false;
        let areas = _.get(reciepts[e], "areas") || null;
        let departments = _.get(reciepts[e], "departments") || null;
        let location_lat = "",
            location_lon = "";
        let route_prefix =
            subject_name === "reports"
                ? "report-view-standalone/"
                : "report-view/";
        let view_route = `${route_prefix}${subject_name}/${subject_child}/${report_type.replace(
            /_/g,
            "-"
        )}/${timestamp.replace(/ /g, "_").replace(/:/g, ".")}`;

        if (subject_name === "reports" && fullReports) {
            location_lat =
                _.get(
                    fullReports[subject_child]["reports"][report_type][
                        timestamp
                    ],
                    "location_lat"
                ) || "";
            location_lon =
                _.get(
                    fullReports[subject_child]["reports"][report_type][
                        timestamp
                    ],
                    "location_lon"
                ) || "";
        } else {
            if (jobPacks && jobPacks[subject_child]) {
                location_lat =
                    _.get(
                        jobPacks[subject_child]["reports"][report_type][
                            timestamp
                        ],
                        "location_lat"
                    ) || "";
                location_lon =
                    _.get(
                        jobPacks[subject_child]["reports"][report_type][
                            timestamp
                        ],
                        "location_lon"
                    ) || "";
            } else {
                location_lat = "";
                location_lon = "";
            }
        }
        return {
            uid,
            urn,
            report_type,
            subject_child,
            areas,
            departments,
            subject_name,
            timestamp,
            worksheet_status,
            uneditable,
            location_lat,
            location_lon,
            view_route:
                uid && report_type && subject_child && subject_name
                    ? view_route
                    : "/submitted-reports-v2",
        };
    });
};

export const selectJobPackIDs = createSelector(
    [selectJobPacksid],
    (totalJobPacks) => {
        if (totalJobPacks === false || totalJobPacks === null) {
            return [];
        }
        let ids = Object.keys(totalJobPacks).map((key, i) => {
            return {
                id: totalJobPacks[key].profile.job_id,
                client_name: totalJobPacks[key].profile.client_name,
                address: totalJobPacks[key].profile.address,
            };
        });
        return ids;
    }
);

export const selectNonInvoicedReports = createSelector(
    [selectTableData],
    (tableData) => {
        let refArray = [];
        if (tableData === false || tableData === null) {
            return [];
        }
        tableData &&
            tableData.map((e) => {
                if (e.worksheet_status !== "invoiced") {
                    refArray.push(e);
                }
                return null;
            });
        return refArray;
    }
);

export const clientDetails = ({ MainReducer }) => {
    let profile = MainReducer.profile;
    if (profile) {
        return profile
    }
    return false
};
